import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import Moment from "moment";
import "moment-timezone";
import { useMemo, useState, React, useEffect, useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { MainContext } from "context/MainContext.js";
import ReactBSAlert from "react-bootstrap-sweetalert";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const NotificationList = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["notifications.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const [params, setParams] = useState(location.state?.value ?? "");

  const columns = useMemo(
    () => [
      {
        Header: "Type",
        accessor: "type",
        sortBy: "type",
        Cell: (props) => {
          return (
            <div>
              {props.value.charAt(0).toUpperCase() + props.value.slice(1)}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Destination",
        accessor: "destination",
        sortBy: "destination",
        flex: "1 1 0",
      },
      {
        Header: "Status",
        accessor: "status",
        sortBy: "status",
        Cell: (props) => {
          return (
            <div>
              {props.value.charAt(0).toUpperCase() + props.value.slice(1)}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Subject",
        accessor: "subject",
        sortBy: "subject",
        flex: "1 1 0",
      },
      {
        Header: "Status Message",
        accessor: "status_message",
        sortBy: "status_message",
        flex: "1 1 0",
      },
      {
        Header: "Creation Date",
        accessor: "creationDate",
        sortBy: "creationDate",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm:ss a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm:ss a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "",
        accessor: "content",
        Cell: (props) => {
          if (props.value) {
            return (
              <UncontrolledDropdown direction="down">
                <DropdownToggle
                  caret
                  color="info"
                  style={{
                    padding: "6px 14px 6px 14px",
                  }}
                >
                  Actions
                </DropdownToggle>
                <DropdownMenu container={"body"}>
                  <DropdownItem
                    onClick={() =>
                      setAlert(
                        <ReactBSAlert
                          style={{ display: "block", marginTop: "-100px" }}
                          onConfirm={() => hideAlert()}
                          onCancel={() => hideAlert()}
                          confirmBtnBsStyle="info"
                          btnSize=""
                        >
                          <div
                            style={{ textAlign: "left" }}
                            dangerouslySetInnerHTML={{ __html: props.value }}
                          ></div>
                        </ReactBSAlert>,
                      )
                    }
                  >
                    Show Content
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            );
          } else {
            return "";
          }
        },
        flex: "1 1 0",
        padding: "0px",
        sortable: false,
        filterable: false,
      },
    ],
    [],
  );

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <div className="content">
      {alert}
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <Breadcrumb>
                <BreadcrumbItem>
                  <NavLink
                    to={{
                      pathname: "/admin/dashboard",
                    }}
                  >
                    <FontAwesomeIcon icon={faHome} />
                  </NavLink>
                </BreadcrumbItem>
                <BreadcrumbItem>Notifications</BreadcrumbItem>
              </Breadcrumb>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <ReactTable
                query="/api/v1/notification/list"
                columns={columns}
                param={params}
                title="Notifications"
                className="-striped -highlight primary-pagination"
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default NotificationList;
